import React, { forwardRef } from "react";
import "./index.scss";
import { graphql, useStaticQuery } from "gatsby";
import { useTranslation } from "react-i18next";
import Img from "gatsby-image";
import FruitIcon from "../FruitIcon";
import Avocado from "../../imageComponents/fruits/default/avocado";
import AvocadoSwooshes from "../../imageComponents/fruits/swooshes/avocado_swooshes";
import Banana from "../../imageComponents/fruits/default/banana";
import BananaSwooshes from "../../imageComponents/fruits/swooshes/banana_swooshes";
import Marrons from "../../imageComponents/fruits/default/marrons";
import Pepper from "../../imageComponents/fruits/default/pepper";
import Bowl from "../../imageComponents/fruits/default/bowl";
import Leaves from "../../imageComponents/fruits/default/leaves";
import Melon from "../../imageComponents/fruits/default/melon";
import MelonSwooshes from "../../imageComponents/fruits/swooshes/melon_swooshes";
import Lemon from "../../imageComponents/fruits/default/lemon";

const ImageWithShadow = ({ fluid, alt, isRtl = false }) => {
  return (
    <div className={`image-with-shadow`}>
      <div className="actual-image-container">
        <Img fluid={fluid} alt={alt} />
      </div>
      <div className={`shadow ${isRtl ? "rtl" : ""}`}></div>
    </div>
  );
};

const OurStory = forwardRef((props, ref) => {
  const { t } = useTranslation();
  const result = useStaticQuery(
    graphql`
      query {
        allImageSharp(
          filter: {
            fluid: {
              originalName: { in: ["about1.png", "about2.png", "about3.png"] }
            }
          }
        ) {
          nodes {
            fluid(maxHeight: 600) {
              originalName
              ...GatsbyImageSharpFluid
            }
          }
        }
      }
    `
  );
  let { allImageSharp = {} } = result || {},
    { nodes = [] } = allImageSharp;
  let images = {};
  nodes.forEach((node) => {
    let { fluid = {} } = node || {},
      { originalName } = fluid;
    originalName = originalName.split(".")[0];
    images[originalName] = fluid;
  });
  const parallaxJiggle = [
    {
      start: "self",
      duration: 3000,
      properties: [
        {
          startValue: 0,
          endValue: 180,
          property: "rotate",
        },
      ],
    },
  ];
  const parallaxGoUp = [
    {
      start: "self",
      duration: 3000,
      properties: [
        {
          startValue: 0,
          endValue: -500,
          property: "translateY",
        },
      ],
    },
  ];
  return (
    <div
      className="layout our-story desktop:container-desktop mobile:container-mobile tablet:container-mobile"
      id="our-story"
      ref={ref}
    >
      <div className="fruits-container">
        <FruitIcon
          className="avocado"
          Icon={Avocado}
          withSwoosh={true}
          Swoosh={AvocadoSwooshes}
          withPlx={true}
          parallaxData={parallaxJiggle}
        />
        <FruitIcon
          className="banana"
          Icon={Banana}
          withSwoosh={true}
          Swoosh={BananaSwooshes}
          withPlx={true}
          parallaxData={parallaxJiggle}
        />
        <FruitIcon
          className="marrons"
          Icon={Marrons}
          withSwoosh={false}
          withPlx={true}
          parallaxData={parallaxGoUp}
        />
        <FruitIcon className="pepper" Icon={Pepper} withSwoosh={false} />
        <FruitIcon
          className="melon"
          Icon={Melon}
          Swoosh={MelonSwooshes}
          withSwoosh={true}
          withPlx={true}
          parallaxData={parallaxJiggle}
        />
        <FruitIcon className="bowl" Icon={Bowl} withSwoosh={false} />
        <FruitIcon className="leaves" Icon={Leaves} withSwoosh={false} />
        <FruitIcon
          className="lemon"
          Icon={Lemon}
          withSwoosh={false}
          withPlx={true}
          parallaxData={parallaxGoUp}
        />
      </div>
      <div className="about-1 about-section">
        <div className="text">
          <div className="title desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1">
            {`${t("about1TitlePart1")}`}
            <br />
            <span>{t("about1TitlePart2")}</span>
          </div>
          <div className="info desktop:desktop-body1 mobile:mobile-body1 tablet:mobile-body1">
            {t("about1Info")}
          </div>
        </div>
        <ImageWithShadow fluid={images["about1"]} alt="Image" />
      </div>
      <div className="about-2 about-section rtl">
        <div className="text">
          <div className="title desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1">
            {`${t("about2TitlePart1")}`}
            <br />
            <span>{t("about2TitlePart2")}</span>
          </div>
          <div className="info desktop:desktop-body1 mobile:mobile-body1 tablet:mobile-body1">
            {t("about2Info")}
          </div>
        </div>
        <ImageWithShadow fluid={images["about2"]} alt="Image" isRtl={true} />
      </div>
      <div className="about-3 about-section">
        <div className="text">
          <div className="title desktop:desktop-h1 mobile:mobile-h1 tablet:mobile-h1">
            {`${t("about3TitlePart1")}`}
            <span>{t("about3TitlePart2")}</span>
            <br />
            <span>{t("about3TitlePart3")}</span>
          </div>
          <div className="info desktop:desktop-body1 mobile:mobile-body1 tablet:mobile-body1">
            {t("about3Info")}
          </div>
        </div>
        <ImageWithShadow fluid={images["about3"]} alt="Image" />
      </div>
      <div className="divider"></div>
    </div>
  );
});

export default OurStory;
